import {useGetTenantQuery} from '@dms/api/core';

/**
 * Hook to get tenant information for vehicle forms
 * Provides easy access to tenant data and derived flags
 */
export function useGetTenantInfo() {
  const {data: tenantData, ...queryResult} = useGetTenantQuery();

  return {
    tenantData,
    isGermanTenant: tenantData?.country === 'DEU',
    ...queryResult,
  };
}
